import { MESSAGE_SOURCE } from "../../constants";

import type { MessagePayload } from "@pubnub/react-chat-components";

type ChatMessageMeta = Record<string, unknown>;

/**
 * Single source of truth for stamping the web app's origin onto an outgoing chat
 * message's `meta.source`, so the backend webhook reads the origin directly
 * instead of defaulting it. Preserves any meta the caller already set. Used by
 * both publish paths: the MessageInput onBeforeSend hook (via
 * withCustomerAppSource) and the file-share follow-up publish.
 *
 * WARNING: THE PUBLISHED MESSAGE SHAPE (text / sender / meta) IS A CONTRACT SHARED
 * WITH THE BACKEND. IT MUST MATCH PubnubClient.publish_user_message AND
 * create_channel_message_from_payload (application/chat/services/pubnub_client,
 * chat_service). DO NOT CHANGE THE SHAPE OR meta KEYS WITHOUT UPDATING THE BACKEND
 * DEFINITION IN THE SAME CHANGE.
 */
export function withCustomerAppSourceMeta(
  meta?: ChatMessageMeta,
): ChatMessageMeta {
  return { ...meta, source: MESSAGE_SOURCE.CUSTOMER_APP };
}

/**
 * Stamp meta.source on a full outgoing MessagePayload (MessageInput onBeforeSend).
 */
export function withCustomerAppSource(payload: MessagePayload): MessagePayload {
  return {
    ...payload,
    meta: withCustomerAppSourceMeta(
      payload.meta as ChatMessageMeta | undefined,
    ),
  };
}
